<div class="card rounded-top-left-0">
    <div class="card-header">
        <h1>Asociar Nota de Entrada a una Órden</h1>
    </div>
    <div class="card-body">
        <div class="mb-3 d-flex gap-3 align-items-end flex-wrap">
      <div class="text-muted">
        <i class="fa fa-circle-info"></i>
        Selecciona una orden a la izquierda y marca las compras a asociar a la derecha. Una compra solo puede estar asociada a una sola orden.
      </div>
    </div>

    <div class="row">
      <svg id="svg-container" #svgContainer></svg>

      <!-- Tabla de Notas de Ingreso -->
      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar orden</label>
          <input type="text" [(ngModel)]="filterEntryNotes" (input)="debouncedFilterNotes()"
                 class="form-control" placeholder="Número de orden / proveedor" />
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-notes">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Número</th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <!-- <th>Total</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let note of entryNotes"
                  [attr.data-id]="note.id"
                  (click)="selectEntryNote(note.id)"
                  [class.selected]="note.id === selectedEntryNoteId">
                <td>
                  <i [ngClass]="note.id === selectedEntryNoteId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <td>{{ note.number }}</td>
                <td>{{ note.providerName }}</td>
                <td>{{ note.date | date:'yyyy-MM-dd HH:mm' }}</td>
                <!-- <td>{{ order.total | number:'1.2-2' }}</td> -->
              </tr>

              <tr *ngIf="orders.length === 0">
                <td colspan="5" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron órdenes.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="orders-pag"
          [sizes]="[5,10,20]"
          (changed)="selectedEntryNoteId = null; refreshEntryNotesPagination()"
          [elements]="paginationEntryNotes">
        </app-simple-pagination>
      </div>


  <!-- Lista de Orders -->
  <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar compra</label>
          <input type="text" [(ngModel)]="filterOrders" (input)="debouncedFilterOrders()"
                 class="form-control" placeholder="Serie-Numero de compra / proveedor" />
          <!-- <div class="mb-3 row">
            <div class="col-md-6">
              <label class="form-label">Fecha inicio</label>
              <input type="date" class="form-control" [(ngModel)]="startDate" (change)="reloadOrders()" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Fecha fin</label>
              <input type="date" class="form-control" [(ngModel)]="endDate" (change)="reloadOrders()" />
            </div>
          </div> -->
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-orders">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Número</th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <th class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let order of orders"
                  [attr.data-id]="order.id"
                  (click)="toggleOrder(order)"
                  [class.selected]="selectedOrderId == order.id"
                  [class.disabled]="isOrderLocked(order)">
                <td>
                    <i [ngClass]="selectedOrderId == order.id ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                  <!-- <i *ngIf="!isOrderLocked(order)"
                     class='fa-regular fa-circle'></i>
                  <i *ngIf="isOrderLocked(order)" class="fa-solid fa-lock"></i> -->
                </td>
                <td>{{ order.number }}</td>
                <td>{{ order.providerName }}</td>
                <td>{{ order.date | date:'yyyy-MM-dd' }}</td>
                <td class="text-center">
                  <span *ngIf="!(currentRelatedId && currentRelatedId === order.id)" class="badge bg-secondary">Sin asociación</span>
                  <span *ngIf="currentRelatedId && currentRelatedId === order.id" class="badge bg-success">Asociada a esta orden</span>
                  <!-- <span *ngIf="p.associatedOrderId && p.associatedOrderId !== selectedOrderId" class="badge bg-warning text-dark">Asociada a otra orden</span> -->
                </td>
              </tr>

              <tr *ngIf="orders.length === 0">
                <td colspan="6" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron compras.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="purchases-pag"
          [sizes]="[5,10,20]"
          (changed)="refreshOrdersPagination()"
          [elements]="paginationOrders">
        </app-simple-pagination>
      </div>
</div>




<!-- Detalles de la Orden -->
<!-- <div class="order-details" *ngIf="currentOrderDetails.length > 0">
  <h4>Detalles de la Orden</h4>
  <table>
    <tr>
      <th>Producto</th>
      <th>Cantidad</th>
      <th>Precio</th>
    </tr>
    <tr *ngFor="let d of currentOrderDetails">
      <td>{{ d.productName }}</td>
      <td>{{ d.quantity }}</td>
      <td>{{ d.price | currency }}</td>
    </tr>
  </table>
</div> -->

<div class="row mt-4">
    <div class="col" *ngIf="selectedEntryNoteId">
        <h5>Detalles de la Nota de Entrada: </h5>
        <div class="row py-2 px-0" *ngIf="currentEntryNote && currentEntryNote.details.length > 0">
                <div class="col">
                    <div class="table-responsive table-bordered">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>Código</th>
                            <th class="text-right bg-warning-subtle">Cantidad</th>
                            <th class="td-center bg-info-subtle">Unidad/Item</th>
                            <th>Description</th>
                            <th class="text-right">Cantidad Recibida</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let detail of currentEntryNote.details">
                            <td>{{ detail.productData.code }}</td>
                            <td class="text-right bg-warning-subtle">{{ detail.quantity }}</td>
                            <td class="td-center bg-info-subtle">{{ detail.item }}</td>
                            <td>{{ detail.productData.name }}</td>
                            <td class="text-right">{{ detail.quantityReceived }}</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
      </div>
      <div class="col" *ngIf="selectedOrderId">
        <h5>Detalles de la Orden: </h5>
        <table class="table table-bordered" id="table-orders">
            <thead>
              <tr class="tr-middle">
                <th>Código</th>
                <th>Nombre</th>
                <th class="">Cantidad</th>
                <th class="">Costo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of currentOrderDetails">
                <td>{{ detail.productData.code }}</td>
                <td>{{ detail.productData.name }}</td>
                <td>{{ detail.quantity }}</td>
                <td>{{detail.cost}}</td>
              </tr>

              <tr *ngIf="currentOrderDetails.length === 0">
                <td colspan="5" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron órdenes.
                </td>
              </tr>
            </tbody>
          </table>
      </div>

</div>
<!-- Botón Guardar -->
<div class="actions">
  <button class="btn btn-success"
          [disabled]="getDisabledSave()"
          (click)="saveAssociation()">
    <i class="fa" [ngClass]="buttonAssociate.icon"></i>
    Guardar
    <!-- {{ buttonAssociate.text }} -->
  </button>
</div>

    </div>
</div>
